module.exports = __webpack_public_path__ + "img/Antonia&Stephan-11.3ee3e1d6.jpg";